module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/ZOOPLA_PEAK2_2767-569bc77230ebc74e7deaa19d21356d26.jpg";